<template>
  <div id="progreso">
    <section class="pantalla">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 contentabs">
            <div class="logo abs" data-aos="fade-up" data-aos-delay="200">
              <img
                src="../../assets/imgs/encauce-logo-blanco-stem.png"
                alt="Encauce"
                class="img-fluid"
              />
            </div>

            <div class="version abs blanco fpG">
              {{this.$store.state.version}}
            </div>

            <div class="info abs" data-aos="fade" data-aos-delay="400">
              <img
                src="../../assets/imgs/progreso/info.png"
                alt="Encauce"
                class="img-fluid"
              />
              <div class="nombre_personaje amarillo fG d-block d-md-none" v-if="userProfile != null">
                {{ userProfile.nombre }}
              </div>
              <div class="nombre_personaje amarillo fXG d-none d-md-block" v-if="userProfile != null">
                {{ userProfile.nombre }}
              </div>
              <div class="texto row">
                <div class="col-12" >
                  <div class="row renglon no-gutters"  v-if="edad != 0">
                    <div class="col-1">
                      <img
                        src="../../assets/imgs/progreso/icono-persona.png"
                        alt="Encauce"
                        class="img-fluid"
                      />
                    </div>
                    <div
                     
                      class="col-10 blanco d-flex justify-content-start align-items-center fpG pl5"
                    >
                      {{ edad }} años
                    </div>
                  </div>

                  <div
                    class="row renglon no-gutters"
                    v-if="
                      membresia != null &&
                      membresia.institucion_nombre != null &&
                      membresia.institucion_nombre != ''
                    "
                  >
                    <div class="col-1">
                      <img
                        src="../../assets/imgs/progreso/icono-mundo.png"
                        alt="Encauce"
                        class="img-fluid"
                      />
                    </div>
                    <div
                      class="col-10 blanco d-flex justify-content-start align-items-center fpG pl5"
                    >
                      {{ membresia.institucion_nombre }}
                    </div>
                  </div>

                  <!-- <div
                    class="row renglon no-gutters"
                    v-if="userProfile.institucion"
                  >
                    <div class="col-1">
                      <img
                        src="../../assets/imgs/progreso/icono-mundo.png"
                        alt="Encauce"
                        class="img-fluid"
                      />
                    </div>
                    <div
                      class="col-10 blanco d-flex justify-content-start align-items-center fpG pl5"
                    >
                      {{ userProfile.institucion }}
                    </div>
                  </div> -->
                  <!-- <div class="row renglon no-gutters" v-if="userProfile.salon">
                    <div class="col-1">
                      <img
                        src="../../assets/imgs/progreso/icono-cohete.png"
                        alt="Encauce"
                        class="img-fluid"
                      />
                    </div>
                    <div
                      class="col-10 blanco d-flex justify-content-start align-items-center fpG pl5"
                    >
                      {{ userProfile.salon }}
                    </div>
                  </div> -->
                </div>
              </div>
            </div>

            <div class="col-12">
              <button @click="salir" class="btn-salir text-center">
                <span class="texto electrico fpG">
                  <span class="bold">Cerrar sesión</span>
                  <svg viewBox="0 0 96 96" xmlns="http://www.w3.org/2000/svg">
                    <g>
                      <path
                        d="M20.4844,54H66a6,6,0,0,0,0-12H20.4844l7.7578-7.7578a5.9994,5.9994,0,0,0-8.4844-8.4844l-18,18a5.9979,5.9979,0,0,0,0,8.4844l18,18a5.9994,5.9994,0,1,0,8.4844-8.4844Z"
                      />
                      <path
                        d="M90,0H42a5.9966,5.9966,0,0,0-6,6V18a6,6,0,0,0,12,0V12H84V84H48V78a6,6,0,0,0-12,0V90a5.9966,5.9966,0,0,0,6,6H90a5.9966,5.9966,0,0,0,6-6V6A5.9966,5.9966,0,0,0,90,0Z"
                      />
                    </g>
                  </svg>
                </span>
              </button>

              <a href="https://soporte.encaucetotal.com/public/es/" target="_blank" class="btn-salir text-center ml-4" title="Crear un ticket de soporte">
                <span class="texto electrico fpG">
                  <span class="bold">Ayuda y soporte</span>
                  <svg id="Layer_1" style="enable-background:new 0 0 128 128;" version="1.1" viewBox="0 0 128 128" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g><path d="M64,1.2C29.3,1.2,1.2,29.3,1.2,64s28.2,62.8,62.8,62.8s62.8-28.2,62.8-62.8S98.7,1.2,64,1.2z M64,8.8   c13.6,0,26,4.9,35.6,13.1L84.4,37c-5.7-4.3-12.8-6.9-20.4-6.9S49.2,32.7,43.6,37L28.4,21.9C38,13.8,50.4,8.8,64,8.8z M90.2,64   c0,14.4-11.7,26.2-26.2,26.2S37.8,78.4,37.8,64S49.6,37.8,64,37.8S90.2,49.6,90.2,64z M8.8,64c0-14.1,5.3-27,14.1-36.7L38,42.4   c-4.9,5.9-7.8,13.4-7.8,21.6c0,7.7,2.6,14.8,6.9,20.4L21.9,99.6C13.8,90,8.8,77.6,8.8,64z M64,119.2c-14.1,0-27-5.3-36.7-14.1   L42.4,90c5.9,4.9,13.4,7.8,21.6,7.8s15.8-2.9,21.6-7.8l15.1,15.1C91,113.8,78.1,119.2,64,119.2z M106.1,99.6L91,84.4   c4.3-5.7,6.9-12.8,6.9-20.4c0-8.2-2.9-15.8-7.8-21.6l15.1-15.1c8.7,9.8,14.1,22.6,14.1,36.7C119.2,77.6,114.2,90,106.1,99.6z"/></g></svg>
                </span>
              </a>


            </div>

            <div
              class="personaje abs"
              data-aos="fade"
              data-aos-delay="800"
              v-if="settings.personaje != null"
            >
              <img
                :src="
                  require('../../assets/imgs/avatar/' +
                    settings.personaje +
                    '.png')
                "
                alt="Encauce"
                class="img-fluid"
              />
              <img
                src="../../assets/imgs/progreso/brillo-amarillo.png"
                alt="Encauce"
                class="img-fluid brillo"
              />
            </div>

            <div
              class="botonera abs text-center"
              data-aos="fade"
              data-aos-delay="800"
            >
              <div class="bgtitulo">
                <img
                  src="../../assets/imgs/progreso/selecciona-vacio.png"
                  alt="Encauce"
                  class="img-fluid"
                />
                <span class="electrico fpG texto"
                  >SELECCIONA <span class="bold"> LA MISIÓN</span> A
                  CONTINUAR</span
                >
              </div>

              <div class="pt5 pb5 d-flex flex-row">
                <div class="mision mision-1 px3">
                  <img
                    src="../../assets/imgs/progreso/bg-btn-mision.png"
                    alt="Encauce"
                    class="img-fluid noevents"
                  />
                  <div @click="selecciona(1)">
                    <img
                      src="../../assets/imgs/progreso/planeta-1.png"
                      alt="Planeta"
                      class="planeta pointer"
                    />
                  </div>
                </div>
                <div class="mision mision-2 px3">
                  <img
                    src="../../assets/imgs/progreso/bg-btn-mision.png"
                    alt="Encauce"
                    class="img-fluid noevents"
                  />
                  <div
                    @click="selecciona(2)"
                    v-if="aprendizaje_usuario != null"
                  >
                    <img
                      src="../../assets/imgs/progreso/planeta-2.png"
                      alt="Planeta"
                      class="planeta pointer"
                    />
                  </div>
                  <div v-else>
                    <img
                      src="../../assets/imgs/progreso/planeta-lock.png"
                      alt="Planeta"
                      class="planeta-lock noevents"
                    />
                  </div>
                </div>
                <div class="mision mision-3 px3">
                  <img
                    src="../../assets/imgs/progreso/bg-btn-mision.png"
                    alt="Encauce"
                    class="img-fluid noevents"
                  />
                  <div @click="selecciona(3)" v-if="resultado_nivel_2 != null">
                    <img
                      src="../../assets/imgs/progreso/planeta-3.png"
                      alt="Planeta"
                      class="planeta pointer"
                    />
                  </div>
                  <div v-else>
                    <img
                      src="../../assets/imgs/progreso/planeta-lock.png"
                      alt="Planeta"
                      class="planeta-lock noevents"
                    />
                  </div>
                </div>
              </div>
              <div
                class="pt2 pb5 d-flex flex-row text-center justify-content-center"
              >
                <div class="mision mision-4 px3">
                  <img
                    src="../../assets/imgs/progreso/bg-btn-mision.png"
                    alt="Encauce"
                    class="img-fluid noevents"
                  />
                  <div @click="selecciona(4)" v-if="resultado_nivel_3 != null">
                    <img
                      src="../../assets/imgs/progreso/planeta-3.png"
                      alt="Encauce"
                      class="img-fluid planeta pointer"
                    />
                  </div>
                  <div v-else>
                    <img
                      src="../../assets/imgs/progreso/planeta-lock.png"
                      alt="Planeta"
                      class="planeta-lock noevents"
                    />
                  </div>
                </div>
                <div class="mision mision-5 px3">
                  <img
                    src="../../assets/imgs/progreso/bg-btn-mision.png"
                    alt="Encauce"
                    class="img-fluid noevents"
                  />
                  <div @click="selecciona(5)" v-if="base_seleccionada != null">
                    <img
                      src="../../assets/imgs/progreso/planeta-3.png"
                      alt="Encauce"
                      class="img-fluid planeta pointer"
                    />
                  </div>
                  <div v-else>
                    <img
                      src="../../assets/imgs/progreso/planeta-lock.png"
                      alt="Planeta"
                      class="planeta-lock noevents"
                    />
                  </div>
                </div>
              </div>

              <div
                v-if="resultado_nivel_3 != null"
                class="d-flex justify-content-center align-items-center pt4"
              >
                <router-link
                  to="/resultados/descarga"
                  class="bgtitulo bgtitulo2 w-100 mx3 pointer glowing"
                >
                  <img
                    src="../../assets/imgs/resultados/btn-resultado-final.png"
                    alt="Encauce"
                    class="img-fluid w-100"
                  />
                  <!-- <div class="texto">
                    
                    <img
                    src="../../assets/imgs/resultados/btn-resultado-final.png"
                    alt="Encauce"
                    class="img-fluid w-100"
                  />
                  </div> -->
                </router-link>
                <router-link to="/vias" class="bgtitulo w-100 mx3 pointer">
                  <img
                    src="../../assets/imgs/progreso/selecciona-vacio.png"
                    alt="Encauce"
                    class="img-fluid w-100"
                  />
                  <div class="texto">
                    <img
                      src="../../assets/imgs/vias/titulo-4.png"
                      alt="Encauce"
                      class="img-fluid w-100 px6"
                    />
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer></Footer>
  </div>
</template>

<script>
import Footer from "@/components/Footer";
import AOS from "aos";
import { mapState } from "vuex";
import swal from "sweetalert2";
import router from "../../router/index";
import * as moment from "moment";

import * as fb from "../../firebase";

export default {
  components: {
    Footer,
  },
  data() {
    return {
      maya_outfit: -1,
      condicion: false,
      avatar: null,
      settings: {
        personaje: null,
        mision: 1,
      },
      avance: [],
      edad: 0,
      nombre_personaje: "",
      aprendizaje_usuario: null,
      resultado_nivel_2: null,
      resultado_nivel_3: null,
      base_seleccionada: null,
      membresia: null,
      initiated: false,
    };
  },
  computed: {
    ...mapState(["userProfile", "institucionID"]),
  },
  watch: {
    userProfile(value) {
      //if (value) alert(this.userProfile.nombre)
      if (value) this.init();
    },
  },
  mounted: function () {
    AOS.init({
      offset: -120, // offset (in px) from the original trigger point
      delay: 0, // values from 0 to 3000, with step 50ms
      duration: 800, // values from 0 to 3000, with step 50ms
      easing: "ease-in-out", // default easing for AOS animations
      once: false, // whether animation should happen only once - while scrolling down
      mirror: false, // whether elements should animate out while scrolling past them
      anchorPlacement: "top-bottom", // defines which position of the element regarding to window should trigger the animation
    });

    this.init();
  },
  methods: {
    init() {
      console.log("iniciando");

      if (this.userProfile == null || this.initiated == true) {
        return;
      }
      this.initiated = true;

      let thes = this;
      setTimeout(function () {
        try {
          thes.edad = moment().diff(thes.userProfile.fecha_nacimiento, "years");
        } catch (e) {
          //error
        }
      }, 1000);

      console.log({ userProfileProgreso: this.userProfile });

      this.getAvance();
      try {
        this.getMembresia();
      } catch (e) {
        //
      }
    },
    async getMembresia() {
      this.membresia = await this.$store.dispatch("getMembresia");
      console.log({membresia: this.membresia})
    },
    async getAvance() {
      this.avance = await this.$store.dispatch("getAvance");
      console.log({ avance: this.avance });

      this.avatar = this.avance.avatar;
      if (this.avatar != null) {
        this.settings.personaje =
          this.avatar.slug_personaje + "-" + this.avatar.id_outfit;
      }

      this.setNombrePersonaje();
      try {
        this.aprendizaje_usuario = this.avance.misiones[0].resultado_evaluacion;
      } catch (e) {
        this.aprendizaje_usuario = null;
      }
      try {
        this.resultado_nivel_2 = this.avance.misiones[1];
      } catch (e) {
        this.resultado_nivel_2 = null;
      }
      try {
        this.resultado_nivel_3 = this.avance.misiones[2].campos_aptos;
      } catch (e) {
        this.resultado_nivel_3 = null;
      }
      try {
        this.base_seleccionada = this.avance.misiones[3].base_seleccionada;
      } catch (e) {
        this.base_seleccionada = null;
      }
    },
    setNombrePersonaje() {
      switch (this.settings.personaje) {
        case "maya-1":
        case "maya-2":
          this.nombre_personaje = "Maya";
          break;
        case "xander-1":
        case "xander-2":
          this.nombre_personaje = "Xander";
          break;
        case "omega-1":
        case "omega-2":
          this.nombre_personaje = "Omega";
          break;
      }
    },
    selecciona(mision) {
      router.push("/mision-" + mision + "-intro");
    },
    salir() {
      this.$router.push("/");
    },
  },
};
</script>

<style lang="scss" scoped>
$amarillo: #ffcc00;
$azul-oscuro: #1545ae;
$cyan: #b1ffff;
@mixin transition($property) {
  -webkit-transition: $property;
  -moz-transition: $property;
  -ms-transition: $property;
  -o-transition: $property;
  transition: $property;
}
#progreso {
  background: url(../../assets/imgs/progreso/bg-progreso.jpg) no-repeat;
  background-size: cover;
  background-position: bottom center;
  .contentabs {
    .logo {
      bottom: 5%;
      right: 5%;
      width: 20%;
      position: absolute;
    }
    .centradoxy {
      position: absolute;
      top: 50%;
      transform: translateY(-50%) translateX(-50%);
      width: 80%;
      left: 50%;
    }
    .personaje {
      bottom: 4%;
      left: 28%;
      width: 20%;
      position: absolute;
      .brillo {
        position: absolute;
        bottom: 0;
        left: 0;
        opacity: 0.5;
        animation: titilar 2s infinite;
      }
    }

    .info {
      width: 40%;
      top: 12%;
      left: 3%;
      position: absolute;
      .nombre_personaje {
        position: absolute;
        width: 100%;
        top: 7vw;
        left: 6vw;
        right: 0px;
      }
      .texto {
        position: absolute;
        top: 14vw;
        left: 0px;
        right: 0px;
        width: 70%;
        margin: 0 15%;
        .renglon {
          border-bottom: 2px dotted $azul-oscuro;
          padding-bottom: 1vw;
          padding-top: 1vw;
          img {
            max-height: 3vw;
          }
        }
      }
    }

    .botonera {
      width: 38%;
      top: 10%;
      left: 53%;
      .bgtitulo {
        width: 80%;
        margin: 0 10%;
        position: relative;
        .texto {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 100%;
          left: 0px;
        }
      }
      .bgtitulo2 {
        width: 100%;
        margin: 0 0%;
      }
      .mision {
        width: 33.33%;
        position: relative;
        .planeta {
          position: absolute;
          left: 0;
          top: 12%;
          width: 70%;
          margin: 0 15%;
        }
        .planeta-lock {
          position: absolute;
          left: 0;
          top: 12%;
          width: 70%;
          margin: 0 15%;
        }
      }
    }

    .btn-avanzar {
      position: absolute;
      top: 2%;
      left: 5%;
    }

    .btn-salir {
      animation: glowing 4s infinite;
      float: left;
      border: none;
      padding: 0px;
      background: $azul-oscuro;
      opacity: 0.8;
      color: $cyan;
      border-radius: 6px;
      overflow: hidden;
      text-align: left;
      @include transition(0.25s all ease-out);
      width: 15.8vw;
      svg {
        padding-left: 1vw;
        width: 2.5vw;
        margin-top: -0.4vw;
        path {
          fill: $cyan;
        }
      }
    }

    @media (min-width: 993px) {
      .personaje {
        bottom: 4%;
        left: 25%;
        width: 25%;
      }
    }
  }
}
</style>
